/* eslint-disable unicorn/prevent-abbreviations */
import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
	selector: '[mspSmoothCollapse]',
	standalone: true,
})
export class CollapseDirective implements AfterViewInit {
	private readonly transitionDuration = 300;
	private isInitialized = false;
	private isTransitioning = false;
	private resizeObserver?: ResizeObserver;
	private collapsed = false;

	@Input('mspSmoothCollapse')
	set smoothCollapse(value: boolean) {
		this.collapsed = value;
		if (this.isInitialized) this.updateCollapseState();
	}

	constructor(
		private el: ElementRef<HTMLElement>,
		private renderer: Renderer2
	) {
		this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
		this.renderer.setStyle(this.el.nativeElement, 'transition', `height ${this.transitionDuration}ms ease`);
	}

	ngAfterViewInit(): void {
		this.isInitialized = true;
		this.updateCollapseState(false);
	}

	private updateCollapseState(animate = true): void {
		const element = this.el.nativeElement;
		this.isTransitioning = animate;
		this.renderer.setStyle(element, 'overflow', 'hidden');

		if (this.collapsed) {
			if (element.style.display === 'none') {
				this.isTransitioning = false;
				return;
			}

			this.setHeight(element.scrollHeight);
			this.forceReflow(element);
			this.setHeight(0);
			if (!animate) this.hideElement();
			return;
		}

		this.renderer.setStyle(element, 'display', '');
		this.setHeight(0);
		this.forceReflow(element);
		this.setHeight(element.scrollHeight);
		if (!animate) {
			this.setHeight('auto');
			this.renderer.setStyle(element, 'overflow', '');
			this.isTransitioning = false;
		}
	}

	private setHeight(height: number | 'auto'): void {
		this.renderer.setStyle(this.el.nativeElement, 'height', typeof height === 'number' ? `${height}px` : height);
	}

	private forceReflow(element: HTMLElement): void {
		void element.offsetHeight;
	}

	private hideElement(): void {
		this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
		this.isTransitioning = false;
	}

	@HostListener('transitionend', ['$event'])
	handleTransitionEnd(event: TransitionEvent): void {
		if (event.propertyName !== 'height' || !this.isTransitioning) return;

		if (this.collapsed) this.hideElement();
		else {
			this.setHeight('auto');
			this.renderer.setStyle(this.el.nativeElement, 'overflow', '');
			this.isTransitioning = false;
		}
	}
}
